import EpaperDetails from './EpaperDetails'

export default EpaperDetails
